import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GateWayService } from 'src/app/services/gateway.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, switchMap, withLatestFrom} from 'rxjs/operators';
import { GateWayTrapActions, GateWayTrapActionTypes } from '../actions/gateway-trap.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {PreferenceService} from '../../../services/preference.service';

@Injectable()
export class GateWayTrapEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private getwayService = inject(GateWayService);
  private preferenceService = inject(PreferenceService);

  constructor() {}

  ReadMgtTrapDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayTrapActionTypes.ReadMgtTrapDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadMgtTrapDetail
      };
      const param = {
        otp: user.otp,
        InfoId: action.payload.InfoId
      }
      return this.getwayService.ReadMgtTrapDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertMgtTrapDetail(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.ReadMgtTrapDetailFail({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadMgtTrapDetailFail()];
        })
      );
    })
  ));
  ReadTrapDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayTrapActionTypes.ReadTrapDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadTrapDetail
      };
      const param = {
        otp: user.otp,
        InfoId: action.payload.InfoId
      }
      return this.getwayService.ReadTrapDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertTrapDetail(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.ReadTrapDetailFail({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadTrapDetailFail()];
        })
      );
    })
  ));
  AddMgtTrapDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayTrapActionTypes.AddMgtTrapDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddMgtTrapDetail
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.AddMgtTrapDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMgtMibTrapList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: 'Add Trap Detail Success', result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Trap Detail Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  UpdateMgtTrapDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayTrapActionTypes.UpdateMgtTrapDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateMgtTrapDetail
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.UpdateMgtTrapDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMgtMibTrapList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: 'Update Trap Detail Success', result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Update Trap Detail Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  DeleteMgtTrapDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayTrapActionTypes.DeleteMgtTrapDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteMgtTrapDetail
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.DeleteMgtTrapDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMgtMibTrapList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: 'Delete Trap Detail Success', result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Delete Trap Detail Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
}
